<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card" v-if="$gate.isAdmin() || $gate.isIren()">
                        <div class="card-header">
                            <h3 class="card-title">Smart Charging Session List</h3>
                        </div>
                        <!-- /.card-header -->
                        <div class="card-body table-responsive p-0">
                            <table class="table table-hover">
                                <thead>
                                <tr>
                                    <th @click="sortBy('SmartChargingSessionID')">
                                        SmartChargingSessionID
                                        <span v-if="sortColumn === 'SmartChargingSessionID'">
                                            <i :class="{'fa fa-sort-asc': sortColumn === 'SmartChargingSessionID' && sortOrder === 'asc', 'fa fa-sort-desc': sortColumn === 'SmartChargingSessionID' && sortOrder === 'desc'}"></i>
                                      </span>
                                    </th>
                                    <th @click="sortBy('MeterStartTime')">
                                        MeterStartTime
                                        <span v-if="sortColumn === 'MeterStartTime'">
                                            <i :class="{'fa fa-sort-asc': sortColumn === 'MeterStartTime' && sortOrder === 'asc', 'fa fa-sort-desc': sortColumn === 'MeterStartTime' && sortOrder === 'desc'}"></i>
                                      </span>
                                    </th>
                                    <th @click="sortBy('PODID')">
                                        PODID
                                        <span v-if="sortColumn === 'PODID'">
                                            <i :class="{'fa fa-sort-asc': sortColumn === 'PODID' && sortOrder === 'asc', 'fa fa-sort-desc': sortColumn === 'PODID' && sortOrder === 'desc'}"></i>
                                        </span>
                                    </th>
                                    <th @click="sortBy('SessionStatus')">
                                        SessionStatus
                                        <span v-if="sortColumn === 'SessionStatus'">
                                            <i :class="{'fa fa-sort-asc': sortColumn === 'SessionStatus' && sortOrder === 'asc', 'fa fa-sort-desc': sortColumn === 'SessionStatus' && sortOrder === 'desc'}"></i>
                                        </span>
                                    </th>
                                    <th @click="sortBy('AccomplishedSessionData')">
                                        AccomplishedSessionData
                                        <span v-if="sortColumn === 'AccomplishedSessionData'">
                                            <i :class="{'fa fa-sort-asc': sortColumn === 'AccomplishedSessionData' && sortOrder === 'asc', 'fa fa-sort-desc': sortColumn === 'AccomplishedSessionData' && sortOrder === 'desc'}"></i>
                                        </span>
                                    </th>
                                    <th @click="sortBy('PODMeterInitialEnergy')">
                                        PODMeterInitialEnergy
                                        <span v-if="sortColumn === 'PODMeterInitialEnergy'">
                                            <i :class="{'fa fa-sort-asc': sortColumn === 'PODMeterInitialEnergy' && sortOrder === 'asc', 'fa fa-sort-desc': sortColumn === 'PODMeterInitialEnergy' && sortOrder === 'desc'}"></i>
                                        </span>
                                    </th>
                                    <th>actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="session in sessions.data" :key="session.SmartChargingSessionID">
                                    <td>{{ session.SmartChargingSessionID }}</td>
                                    <td>{{ formatDate(session.MeterStartTime) }}</td>
                                    <td>{{ session.PODID }}</td>
                                    <td>{{ session.SessionStatus }}</td>
                                    <td>
                                        <div v-if="session.AccomplishedSessionData">
                                            <p v-if="session.AccomplishedSessionData.MeterSessionFinalEnergy">
                                                <strong>Final Energy:</strong>
                                                {{ session.AccomplishedSessionData.MeterSessionFinalEnergy.value }} {{ session.AccomplishedSessionData.MeterSessionFinalEnergy.unit_of_measure }}
                                            </p>
                                            <p v-else>No final energy data available.</p>

                                            <p v-if="session.AccomplishedSessionData.TimeOfComplete">
                                                <strong>Completion Time:</strong>
                                                {{ formatDate(session.AccomplishedSessionData.TimeOfComplete) }}
                                            </p>
                                            <p v-else>No completion time available.</p>

                                            <p v-if="session.AccomplishedSessionData.CompleteReasonCodeOCPP">
                                                <strong>Complete Reason Code:</strong>
                                                {{ session.AccomplishedSessionData.CompleteReasonCodeOCPP }}
                                            </p>
                                            <p v-else>No complete reason code available.</p>

                                            <p v-if="session.AccomplishedSessionData.CompleteReasonDescription">
                                                <strong>Complete Reason:</strong>
                                                {{ session.AccomplishedSessionData.CompleteReasonDescription }}
                                            </p>
                                            <p v-else>No complete reason available.</p>
                                        </div>
                                        <div v-else>
                                            <p>No session data available.</p>
                                        </div>
                                    </td>
                                    <td>{{ session.PODMeterInitialEnergy }}</td>
                                    <td>
                                        <a href="#" @click.prevent="showSession(session)" title="View Details">
                                            <i class="fa-solid fa-info-circle"></i>
                                        </a>
                                        /
                                        <a href="#" @click.prevent="deleteSession(session.SmartChargingSessionID)">
                                            <i class="fa fa-trash red"></i>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- /.card-body -->
                        <div class="card-footer">
                            <pagination :data="sessions" @pagination-change-page="getResults"></pagination>
                        </div>
                    </div>
                    <!-- /.card -->
                </div>
                <!-- Modal to view session details -->
                <div class="modal fade" id="viewSessionModal" tabindex="-1" role="dialog" aria-labelledby="viewSessionModalLabel" aria-hidden="true">
                    <div class="modal-dialog session-details-modal" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="viewSessionModalLabel">Session Details</h5>
                                <!--
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                -->
                            </div>
                            <div class="modal-body" v-if="selectedSession">
                                <p><strong>SmartChargingSessionID:</strong> {{ selectedSession.SmartChargingSessionID }}</p>
                                <p><strong>MeterStartTime:</strong> {{ formatDate(selectedSession.MeterStartTime) }}</p>
                                <p><strong>PODID:</strong> {{ selectedSession.PODID }}</p>
                                <p><strong>SessionStatus:</strong> {{ selectedSession.SessionStatus }}</p>
                                <p><strong>Energy: </strong>{{ energyDifference }} Wh</p>

                                <!-- Clickable AccomplishedSessionData section -->
                                <p @click="toggleAccomplishedSessionData" style="cursor: pointer; color: blue;">
                                    <strong>AccomplishedSessionData:</strong>
                                    <i :class="{'fa fa-chevron-down': !showAccomplishedSessionData, 'fa fa-chevron-up': showAccomplishedSessionData}"></i>
                                </p>
                                <div v-if="showAccomplishedSessionData && selectedSession.AccomplishedSessionData">
                                    <p><strong>Final Energy:</strong> {{ formatEnergy(selectedSession.AccomplishedSessionData.MeterSessionFinalEnergy.value) }} {{ selectedSession.AccomplishedSessionData.MeterSessionFinalEnergy.unit_of_measure }}</p>
                                    <p><strong>Completion Time:</strong> {{ formatDate(selectedSession.AccomplishedSessionData.TimeOfComplete) }}</p>
                                    <p><strong>Complete Reason Code:</strong> {{ selectedSession.AccomplishedSessionData.CompleteReasonCodeOCPP }}</p>
                                    <p><strong>Complete Reason:</strong> {{ selectedSession.AccomplishedSessionData.CompleteReasonDescription }}</p>
                                </div>
                                <p><strong>PODMeterInitialEnergy:</strong> {{ selectedSession.PODMeterInitialEnergy }}</p>

                                <!-- Clickable PowerFactor section -->
                                <p @click="toggleShowPowerFactor" style="cursor: pointer; color: blue;">
                                    <strong>PowerFactor:</strong>
                                    <i :class="{'fa fa-chevron-down': !showPowerFactor, 'fa fa-chevron-up': showPowerFactor}"></i>
                                </p>

                                <div v-if="showPowerFactor">
                                    <template v-if="selectedSession && selectedSession.PowerFactor && selectedSession.PowerFactor.LoadCurve && selectedSession.PowerFactor.LoadCurve.length">
                                        <table class="table table-hover">
                                            <thead>
                                            <tr>
                                                <th>Timestamp</th>
                                                <th>PowerFactor (V)</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(point, index) in selectedSession.PowerFactor.LoadCurve" :key="index">
                                                <td>{{ formatTimestamp(point.timestamp) }}</td>
                                                <td>{{ point.powerFactor }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </template>
                                    <template v-else>
                                        <p>No data available</p>
                                    </template>
                                </div>

                                <!-- Clickable ConnectorStatus section -->
                                <p @click="toggleShowConnectorStatus" style="cursor: pointer; color: blue;">
                                    <strong>Connector Status:</strong>
                                    <i :class="{'fa fa-chevron-down': !showConnectorStatus, 'fa fa-chevron-up': showConnectorStatus}"></i>
                                </p>

                                <div v-if="showConnectorStatus">
                                    <template v-if="selectedSession && selectedSession.ConnectorStatus && selectedSession.ConnectorStatus.LoadCurve && selectedSession.ConnectorStatus.LoadCurve.length">
                                        <table class="table table-hover">
                                            <thead>
                                            <tr>
                                                <th>Timestamp</th>
                                                <th>ConnectorStatus</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(point, index) in selectedSession.ConnectorStatus.LoadCurve" :key="index">
                                                <td>{{ formatTimestamp(point.timestamp) }}</td>
                                                <td>{{ point.ConnectorStatus }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </template>
                                    <template v-else>
                                        <p>No data available</p>
                                    </template>
                                </div>

                                <!-- Clickable ThreePhaseVoltageCurve section -->
                                <p @click="toggleThreePhaseVoltageCurve" style="cursor: pointer; color: blue;">
                                    <strong>Three Phase Voltage Curve:</strong>
                                    <i :class="{'fa fa-chevron-down': !showThreePhaseVoltageCurve, 'fa fa-chevron-up': showThreePhaseVoltageCurve}"></i>
                                </p>

                                <div v-if="showThreePhaseVoltageCurve">
                                    <template v-if="selectedSession && selectedSession.ThreePhaseVoltageCurve && selectedSession.ThreePhaseVoltageCurve.LoadCurve && selectedSession.ThreePhaseVoltageCurve.LoadCurve.length">
                                        <table class="table table-hover">
                                            <thead>
                                            <tr>
                                                <th>Timestamp</th>
                                                <th>Voltage L1-N (V)</th>
                                                <th>Voltage L2-N (V)</th>
                                                <th>Voltage L3-N (V)</th>
                                                <th>Voltage L1-L2 (V)</th>
                                                <th>Voltage L2-L3 (V)</th>
                                                <th>Voltage L3-L1 (V)</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(point, index) in selectedSession.ThreePhaseVoltageCurve.LoadCurve" :key="index">
                                                <td>{{ formatTimestamp(point.timestamp) }}</td>
                                                <td>{{ point.ThreePhaseVoltage.VoltageL1N }}</td>
                                                <td>{{ point.ThreePhaseVoltage.VoltageL2N }}</td>
                                                <td>{{ point.ThreePhaseVoltage.VoltageL3N }}</td>
                                                <td>{{ point.ThreePhaseVoltage.VoltageL1L2.toFixed(2) }}</td>
                                                <td>{{ point.ThreePhaseVoltage.VoltageL2L3.toFixed(2) }}</td>
                                                <td>{{ point.ThreePhaseVoltage.VoltageL3L1.toFixed(2) }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </template>
                                    <template v-else>
                                        <p>No data available</p>
                                    </template>
                                </div>


                                <!-- Clickable ThreePhaseCurrentCurve section -->
                                <p @click="toggleThreePhaseCurrentCurve" style="cursor: pointer; color: blue;">
                                    <strong>Three Phase Current Curve:</strong>
                                    <i :class="{'fa fa-chevron-down': !showThreePhaseCurrentCurve, 'fa fa-chevron-up': showThreePhaseCurrentCurve}"></i>
                                </p>

                                <div v-if="showThreePhaseCurrentCurve">
                                    <template v-if="selectedSession && selectedSession.ThreePhaseCurrentCurve && selectedSession.ThreePhaseCurrentCurve.LoadCurve && selectedSession.ThreePhaseCurrentCurve.LoadCurve.length">
                                        <table class="table table-hover">
                                            <thead>
                                            <tr>
                                                <th>Timestamp</th>
                                                <th>Current L1 (A)</th>
                                                <th>Current L2 (A)</th>
                                                <th>Current L3 (A)</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(point, index) in selectedSession.ThreePhaseCurrentCurve.LoadCurve" :key="index">
                                                <td>{{ formatTimestamp(point.timestamp) }}</td>
                                                <td>{{ point.ThreePhaseCurrent.CurrentL1 }}</td>
                                                <td>{{ point.ThreePhaseCurrent.CurrentL2 }}</td>
                                                <td>{{ point.ThreePhaseCurrent.CurrentL3 }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </template>
                                    <template v-else>
                                        <p>No data available</p>
                                    </template>
                                </div>


                                <!-- Clickable RealLoadCurve section -->
                                <p @click="toggleRealLoadCurve" style="cursor: pointer; color: blue;">
                                    <strong>RealLoadCurve:</strong>
                                    <i :class="{'fa fa-chevron-down': !showRealLoadCurve, 'fa fa-chevron-up': showRealLoadCurve}"></i>
                                </p>
                                <table class="table table-hover" v-show="showRealLoadCurve">
                                    <thead>
                                    <tr>
                                        <th>Timestamp</th>
                                        <th>Power (kW)</th>
                                    </tr>
                                    </thead>
                                    <tbody v-if="selectedSession && selectedSession.RealLoadCurve && selectedSession.RealLoadCurve.LoadCurve">
                                    <tr v-for="(point, index) in selectedSession.RealLoadCurve.LoadCurve" :key="index">
                                        <td>{{ formatTimestamp(point.timestamp) }}</td>
                                        <td>{{ formatPower(point.power) }}</td>
                                    </tr>
                                    </tbody>

                                </table>

                                <!-- Clickable RealEnergyCurve section -->
                                <p @click="toggleRealEnergyCurve" style="cursor: pointer; color: blue;">
                                    <strong>RealEnergyCurve:</strong>
                                    <i :class="{'fa fa-chevron-down': !showRealEnergyCurve, 'fa fa-chevron-up': showRealEnergyCurve}"></i>
                                </p>
                                <table class="table table-hover" v-show="showRealEnergyCurve">
                                    <thead>
                                    <tr>
                                        <th>Timestamp</th>
                                        <th>Energy (Wh)</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(data, index) in combinedUniqueData" :key="index">
                                        <td>{{ formatTimestamp(data.timestamp) }}</td>
                                        <td>{{ formatEnergy(data.energy) }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import moment from 'moment';
import { DateTimePicker } from '@progress/kendo-dateinputs-vue-wrapper';
export default {
    components: {
        'kendo-datetimepicker': DateTimePicker
    },
    data() {
        return {
            selectedSession: null, // To store the session details
            showRealLoadCurve: false, // State to control RealLoadCurve visibility
            showRealEnergyCurve: false, // State to control RealEnergyCurve visibility
            showAccomplishedSessionData: false,
            showThreePhaseVoltageCurve: false,
            showThreePhaseCurrentCurve: false,
            showPowerFactor: false,
            showConnectorStatus: false,
            editmode: false,
            sessions: {
                data: []
            },
            energyData: {}, // Array to store the new rows
            sortColumn: 'SmartChargingSessionID',  // Default sort column
            sortOrder: 'desc',              // Default sort order (ascending)
            form: new Form({
                SmartChargingSessionID: '',
                RealLoadCurve: '',
                RealEnergyCurve: '',
                MeterStartTime: '',
                PODID: '',
                SessionStatus: '',
                AccomplishedSessionData: '',
                PODMeterInitialEnergy: '',
            }),
            isLoading: false // Loading state
        };
    },
    filters: {
        moment: function (date) {
            return moment(date).format('YYYY-MM-DD hh:mm:ss');
        }
    },
    computed: {
        combinedUniqueData() {
            // Extract the energy data for the selected session
            const sessionEnergyData = this.energyData[this.selectedSession.SmartChargingSessionID] || [];

            // Combine both arrays
            const combinedData = [
                ...this.selectedSession.RealEnergyCurve.EnergyCurve,
                ...sessionEnergyData
            ];

            // Filter out duplicates based on timestamp
            const uniqueData = combinedData.reduce((acc, curr) => {
                const existing = acc.find(item => item.timestamp === curr.timestamp);
                if (!existing) {
                    acc.push(curr);
                }
                return acc;
            }, []);

            return uniqueData;
        },
        energyDifference() {
            const combinedData = this.combinedUniqueData; // Access as a property, not a function
            if (combinedData && combinedData.length > 1) {
                const firstEnergy = combinedData[0].energy;
                const lastEnergy = combinedData[combinedData.length - 1].energy;
                return this.formatEnergy(lastEnergy - firstEnergy);
            }
            return this.formatEnergy(0); // Return 0 if there is not enough data
        }

    },
    methods: {
        getResults(page = 1) {
            this.isLoading = true;
            axios.get(`api/smart-charging-sessions?page=${page}&sortColumn=${this.sortColumn}&sortOrder=${this.sortOrder}`)
                .then(response => {
                    this.sessions = response.data;
                    this.sessions.data.forEach(session => {
                        if (session.AccomplishedSessionData) {
                            session.AccomplishedSessionData = JSON.parse(session.AccomplishedSessionData);
                        }
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        formatTimestamp(timestamp) {
            if (!timestamp) {
                return 'N/A';
            }

            let date;
            if (timestamp instanceof Date) {
                date = timestamp;
            } else if (typeof timestamp === 'number' || typeof timestamp === 'string') {
                // If timestamp is a UNIX timestamp in seconds, convert it to milliseconds
                date = new Date(typeof timestamp === 'number' ? timestamp * 1000 : timestamp);
            } else {
                return 'Invalid date';
            }

            return date.toLocaleString('en-US', {
                month: 'numeric',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: true
            });
        },
        formatPower(power) {
            if (power === undefined || power === null) {
                return 'N/A';
            }
            return power.toFixed(2); // Format power to two decimal places
        },
        formatEnergy(energy) {
            if (energy === undefined || energy === null) {
                return 'N/A';
            }
            return energy.toFixed(2); // Format energy to two decimal places
        },
        formatDate(date) {
            return moment(date).format('YYYY-MM-DD HH:mm:ss');
        },
        toggleRealLoadCurve() {
            this.showRealLoadCurve = !this.showRealLoadCurve; // Toggle the visibility
        },
        toggleRealEnergyCurve() {
            this.showRealEnergyCurve = !this.showRealEnergyCurve; // Toggle the visibility
        },
        toggleAccomplishedSessionData() {
            this.showAccomplishedSessionData = !this.showAccomplishedSessionData;
        },
        toggleThreePhaseVoltageCurve() {
            this.showThreePhaseVoltageCurve = !this.showThreePhaseVoltageCurve; // Toggle the visibility
        },
        toggleThreePhaseCurrentCurve() {
            this.showThreePhaseCurrentCurve = !this.showThreePhaseCurrentCurve; // Toggle the visibility
        },
        toggleShowPowerFactor() {
            this.showPowerFactor = !this.showPowerFactor;
        },
        toggleShowConnectorStatus() {
            this.showConnectorStatus = !this.showConnectorStatus;
        },
        sortBy(column) {
            // Toggle sort order if the same column is clicked
            if (this.sortColumn === column) {
                this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortColumn = column;
                this.sortOrder = 'asc'; // Default to ascending if a new column is sorted
            }
            this.getResults(); // Reload data with new sorting
        },
        editModal(session){
            this.editmode = true;
            this.form.reset();
            $('#addNew').modal('show');
            this.form.fill(session);
        },
        newModal(){
            this.editmode = false;
            this.form.reset();
            $('#addNew').modal('show');
        },
        loadSessions() {
            this.isLoading = true;
            axios.get('api/smart-charging-sessions/')
                .then((response) => {
                    // Parse AccomplishedSessionData for each session
                    this.sessions = response.data;
                    this.sessions.data.forEach(session => {
                        if (session.AccomplishedSessionData) {
                            session.AccomplishedSessionData = JSON.parse(session.AccomplishedSessionData);
                        }
                    });
                })
                .catch((error) => {
                    console.error('Error fetching Smart Charging Session:', error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        /*
        Method used for update a session when we receive a new event.
         */
        updateSession(updatedSession) {
            //console.log("updatedSession: ", updatedSession);
            //console.log("meterData", updatedSession.meterData);

            const { smartChargingSession, meterData } = updatedSession;

            if (smartChargingSession?.RealEnergyCurve?.EnergyCurve?.length > 0) {
                let sessionToUpdate = Array.isArray(this.sessions.data) ?
                    this.sessions.data.find(session => session.SmartChargingSessionID === smartChargingSession.SmartChargingSessionID) :
                    null;

                if (sessionToUpdate) {
                    this.$set(sessionToUpdate, 'SessionStatus', smartChargingSession.SessionStatus);
                    this.$set(sessionToUpdate, 'RealEnergyCurve', smartChargingSession.RealEnergyCurve);
                    this.$set(sessionToUpdate, 'RealLoadCurve', smartChargingSession.RealLoadCurve);
                } else {
                    const newSession = {
                        SmartChargingSessionID: smartChargingSession.SmartChargingSessionID,
                        SessionStatus: smartChargingSession.SessionStatus,
                        PODID: smartChargingSession.PODID,
                        RealEnergyCurve: smartChargingSession.RealEnergyCurve,
                        MeterStartTime: this.formatDate(smartChargingSession.MeterStartTime),
                        PODMeterInitialEnergy: smartChargingSession.PODMeterInitialEnergy,
                        AccomplishedSessionData: smartChargingSession.AccomplishedSessionData
                    };
                    this.sessions.data.unshift(newSession);
                }
            }

            if (meterData) {
                //console.log("Session is still charging..", updatedSession);

                const sessionToUpdate = this.sessions.data.find(session => session.SmartChargingSessionID === updatedSession.smartChargingSession);
                //console.log("sessionToUpdate", sessionToUpdate);
                //console.log("meterData:", meterData);
                //console.log(updatedSession.meterData?.CompleteReasonDescription);
                if (updatedSession.meterData?.CompleteReasonDescription === 'Charging session ended successfully') {
                    if (sessionToUpdate) {
                        this.$set(sessionToUpdate, 'AccomplishedSessionData', meterData);
                        this.$set(sessionToUpdate, 'SessionStatus', 'Accomplished');
                    }
                }
                else {
                    const newMeterData = updatedSession.meterData.map(data => { // Make sure to use updatedSession.meterData
                        //console.log(data.timestamp);

                        return {
                            timestamp: this.formatTimestamp(data.timestamp), // Use the formatTimestamp method
                            power: data.power,
                            energy: data.energy * 1000, // Convert kWh to Wh
                            PowerUnitOfMeasure: 'kW',
                            EnergyUnitOfMeasure: 'Wh'
                        };
                    }).filter(data => data !== null); // Remove any null entries

                    //console.log("sessionToUpdate.RealEnergyCurve.energyCurve:", sessionToUpdate.RealEnergyCurve?.EnergyCurve);

                    newMeterData.forEach(data => {
                        // Check if timestamp already exists in the RealEnergyCurve
                        const energyCurveExists = sessionToUpdate.RealEnergyCurve.EnergyCurve.find(entry => entry.timestamp === this.formatTimestamp(data.timestamp));

                        if (!energyCurveExists) {
                            sessionToUpdate.RealEnergyCurve.EnergyCurve.push({
                                energy: data.energy,
                                timestamp: data.timestamp // Use the formatted timestamp here
                            });
                        }

                        // Check if timestamp already exists in the RealLoadCurve
                        const loadCurveExists = sessionToUpdate.RealLoadCurve.LoadCurve.find(entry => entry.timestamp === data.timestamp);

                        if (!loadCurveExists) {
                            sessionToUpdate.RealLoadCurve.LoadCurve.push({
                                power: data.power,
                                timestamp: data.timestamp // Use the formatted timestamp here
                            });
                        }
                    });

                    this.$set(sessionToUpdate, 'RealLoadCurve', sessionToUpdate.RealLoadCurve);
                    this.$set(sessionToUpdate, 'RealEnergyCurve', sessionToUpdate.RealEnergyCurve);
                }
            }
        },
        deleteSession(id) {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) {
                    this.form.delete('api/smart-charging-sessions/'+id).then(()=>{
                        Swal.fire(
                            'Deleted!',
                            'Smart Charging Session has been deleted.',
                            'success'
                        );
                    }).catch((data)=> {
                        Swal.fire("Failed!", data.message, "warning");
                    });
                }
            })
        },
        showSession(session) {
            this.selectedSession = session; // Store the session details
            $('#viewSessionModal').modal('show'); // Show the modal
        },
        closeModal(){
            this.selectedSession = null;
            $('#viewSessionModal').modal('hide');
        },
    },
    /*
    created() {
        this.loadSessions();
    }
    */
    mounted() {
        // Listen for real-time updates
        Echo.channel('meter-readings')
            .listen('MeterReadingUpdated', (event) => {
                // Handle the event to update the session
                this.updateSession(event);
            });

        this.loadSessions(); // Initial data load
    },
};
</script>

<style scoped>
/* Custom styling for the session details modal */
.session-details-modal {
    max-width: 80%; /* Increase the width of the modal */
    width: 80%;     /* You can adjust this percentage as needed */
}

.session-details-modal .modal-content {
    height: 80vh;   /* Set the height of the modal */
    overflow-y: auto; /* Ensure the content can scroll if it overflows */
}

.table-hover tbody tr:hover {
    background-color: #f5f5f5; /* Optional: enhance table row hover effect */
}
</style>
